import { ConfigService } from '@axo/config/ConfigService';
import { Purpose } from '@axo/shared/data-access/types';
import { useAxoFormContext } from '../context/AxoForm/AxoForm';
import { FormViewOptions } from '../types';
import {
  getMarketingConsentDefaultValues,
  type MarketingConsentFields,
} from './useMarketingConsent';

type Step1GenericData = {
  'LoanApplication/AppliedAmount': number;
  'LoanApplication/LoanDuration': number;
  'LoanApplication/InitialPurpose'?: Purpose;
  'LoanApplication/Purpose'?: Purpose;
  'Customer/Email': string;
  'Customer/MobilePhoneNumber': string;
} & MarketingConsentFields;

export const useAxoFormDefaultValues = (
  options?: FormViewOptions['options']
) => {
  const {
    amount: { default: defaultAppliedAmount },
    duration: { default: defaultLoanDuration },
  } = ConfigService.get('product-unsecured-loan').config;

  const { axoFormData } = useAxoFormContext<Step1GenericData>();

  return {
    'LoanApplication/InitialPurpose': options?.refinancing
      ? Purpose.RefinancingLoan
      : Purpose.Other,
    'LoanApplication/AppliedAmount':
      axoFormData['LoanApplication/AppliedAmount'] ||
      options?.defaultLoanAmount ||
      defaultAppliedAmount,
    'LoanApplication/LoanDuration':
      axoFormData['LoanApplication/LoanDuration'] ||
      options?.defaultLoanDuration ||
      defaultLoanDuration,
    'Customer/Email': '',
    'Customer/MobilePhoneNumber': '',
    ...getMarketingConsentDefaultValues({
      marketingConsent: axoFormData['Ignore/MarketingConsent'],
      showMarketingConsent: axoFormData['Ignore/ShowMarketingConsent'],
      defaultValueOverride: false,
    }),
  };
};
